module.exports = __webpack_public_path__ + "img/logos-bar1.f80baf53.jpg";